import mealPlaceholder from "../assets/meal-placeholder.png";

interface BrandProps {
  name: string;
  imageUrl?: string;
  onClick?: () => void;
}

export default function Brand({
  name,
  imageUrl,
  onClick = () => {},
}: BrandProps) {
  return (
    <div className="p-1 flex flex-col items-center gap-2">
      <div
        className="hover:scale-105 transition-all duration-300 cursor-pointer"
        onClick={onClick}
      >
        <img
          src={imageUrl ? imageUrl : mealPlaceholder}
          className="object-contain h-24 w-24 sm:h-36 sm:w-36 rounded-full bg-gray-200"
        />
      </div>
      <span className="text-sm sm:text-base">{name}</span>
    </div>
  );
}
